import React from 'react'
import CountUp from 'react-countup';

const FunFact = (props) => {
    return (

        <section className={"" + props.hclass}>
            <div className="container mt-lg-4 mb-lg-5">
                <div className="row">
                    <div className="col col-lg-3 col-md-6 col-6">
                        <div className="item">
                            <h3><span><CountUp end={50} enableScrollSpy duration={4} /></span>+</h3>
                            <h4>Happy Clients</h4>
                        </div>
                    </div>
                    <div className="col col-lg-3 col-md-6 col-6">
                        <div className="item">
                            <h3><span><CountUp end={100} enableScrollSpy duration={4} /></span>+</h3>
                            <h4>Account Numbers</h4>
                        </div>
                    </div>
                    <div className="col col-lg-3 col-md-6 col-6">
                        <div className="item">
                            <h3><span><CountUp end={70} enableScrollSpy duration={4} /></span>+</h3>
                            <h4>Finished Projects</h4>
                        </div>
                    </div>
                    <div className="col col-lg-3 col-md-6 col-6">
                        <div className="item">
                            <h3><span><CountUp end={150} enableScrollSpy duration={4} /></span>+</h3>
                            <h4>Winning Success</h4>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default FunFact;




